define([
	"./_AutoSize",
	"./PluginFactory"
], function(_AutoSize,PluginFactory) {

	return PluginFactory.declare(_AutoSize, {
		"class": "csi-button-toggle csi-toggle-group-last",
		cssValue: "FIXED_SIZE",
		iconClass: "csiActionIcon svgIconAutosizeFixed",
		pluginName: "fixedSize",
		title: "CanvasAutosizeFixedSize"
	});
});
